<template>
    <div class="note">
        <div class="note-details">
            <span class="note-user">{{ comb(user.firstName, ' ', user.lastName) }}</span>
            <span class="note-date">{{ date | moment("MM/DD/YYYY h:mma") }}</span>
        </div>
        <div class="note-message">{{ message }}</div>
    </div>
</template>

<script>
import { comb } from '@/utilities'

export default {
    name: 'note',
    props: ['message', 'date', 'user'],
    methods: {
        comb
    }
}
</script>

<style lang="stylus">
@import '../../../../stylus/variables'

.note
    background: $lighter-grey
    border: 1px solid $border-color
    padding: 10px 20px
    border-radius: 3px
    margin-bottom: 5px
    position: relative
    color: $text-dark-grey

    .note-details
        padding: 0px 0px 5px

    .note-user
        font-weight: 500
        font-size: 14px

    .note-date
        font-size: 13px
        color: $medium-grey
        position: absolute
        top: 12px
        right: 20px
</style>
